import { render, staticRenderFns } from "./LinkPage.vue?vue&type=template&id=011e3afa"
import script from "./LinkPage.vue?vue&type=script&lang=js"
export * from "./LinkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports